(function() {
  'use strict';

  angular
    .module('inspinia', 
      [
        'ngAnimate', 
        'ngCookies', 
        'ngTouch', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ngResource', 
        'ui.router',           
        'ui.bootstrap',
        'ngStorage',
        'ngMask',
        'toastr',
        'ui-leaflet',
        'summernote',
        'chart.js',
        'ui.select',
        'datePicker',
        'cgBusy',
        'ui.utils.masks'
      ]);
})();

'use strict';

angular.module('inspinia')
  .controller('BoletoVencidoItauGerarController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'codigo', 'antecipacao', '$http', 'APP_MNP',
      function($scope, $state, toastr, $uibModalInstance, codigo, antecipacao, $http, APP_MNP)
  {
    var vm = this;
    vm.codigo = codigo;
    vm.antecipacao = antecipacao;

    vm.init = function()
    {
      /*
      vm.consultaPromise = $http.get(APP_API_FRND + "/ccb/antecipacaodetalhe/" + antecipacao.viewId)
      .then(function(response)
      { 
        vm.registro = response.data;
      });
      */
    }

    vm.visualizarBoleto = function() {
      vm.consultaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
          
          vm.download(response, 'application/pdf', 'boleto.pdf');

          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

}]);
'use strict';

angular.module('inspinia') 
  .controller('BoletoVencidoGerarController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_MNP', '$uibModal', 'AuthService',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_MNP, $uibModal, AuthService)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.usoDeBoleto = AuthService.getUsoDeBoleto();


    vm.init = function()
    {
      /*
      vm.consultaPromise = $http.get(APP_API_FRND + "/ccb/antecipacaodetalhe/" + antecipacao.viewId)
      .then(function(response)
      { 
        vm.registro = response.data;
      });
      */
    }

    vm.visualizarBoleto = function() {
      antecipacao.isGerarAtualizado = false;
      
      vm.consultaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
          
          //vm.download(response, 'application/pdf', 'boleto.pdf');
          var modalInstance = $uibModal.open({
              templateUrl: 'app/email/carteira/modal/boleto/index.html',
              controller: 'CarteiraModalBoletoController',
              controllerAs: 'controller',
              windowClass: 'inmodal',
              size: 'lg',
              resolve: {
                  item: function () {
                      return response;
                  },
              }
          }).closed.then(function(){
              //vm.listar();
          });

          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
    }

    vm.visualizarBoletoAtualizado = function() {
      antecipacao.isGerarAtualizado = true;

      vm.consultaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
          
          //vm.download(response, 'application/pdf', 'boleto.pdf');
          var modalInstance = $uibModal.open({
            templateUrl: 'app/email/carteira/modal/boleto/index.html',
            controller: 'CarteiraModalBoletoController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                item: function () {
                    return response;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });

          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('CarteiraModalBoletoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_MNP', 'item', '$sce',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_MNP, item, $sce)
  {
    var vm = this;
    vm.item = item;

    vm.init = function()
    {
      vm.filePdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + vm.item);
    }

    vm.visualizarBoleto = function() {
      $uibModalInstance.close(false);
    }

    vm.visualizarBoletoAtualizado = function() {
      $uibModalInstance.close(true);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('EmailCarteiraDinamicaController', ['$scope', '$state', 'toastr', '$http','APP_MNP', 'PagerService', '$uibModal', 'AuthService', 'modalService',
      function($scope, $state, toastr, $http, APP_MNP, PagerService, $uibModal, AuthService, modalService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        cedente: null,
        sacado: null,
        operacaoInicial: null,
        operacaoFinal: null,
        vencimentoInicial: null,
        vencimentoFinal: null,
        tipoSacado: 0,
    };
    vm.pager = {};
    vm.setPage = setPage;
    vm.cedente = null;
    vm.email = '';
    vm.cedenteViewId = '';
    vm.selecionadoTodos = false;
    vm.opcaoAtualizarBoleto = true;
    vm.empresaId = AuthService.getEmpresaId();
    vm.userEmail = AuthService.getUserEmail();
    vm.cnpjUsuarioSacado = AuthService.getCnpjUsuarioSacado();



    // Adicione a função redirectToURL ao vm
    vm.redirectToURL = function() {
        var url = 'https://venturenegocios.com.br/wp-content/uploads/2024/12/IF-GERAÇÃO-DE-BOLETOS.pdf';
        modalService.openModal(url);
    };

    vm.selecionarTodos = function() {
        var selecionado = vm.selecionadoTodos;
        for (var i=0; i<vm.registros.length;i++) {
            vm.registros[i].selecionado = selecionado;
        }
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        if (vm.empresaId == '836c9e79-3d37-4a9c-a618-9925f1136e3d') {
            // Desabilitar atualizacao de boleto
            vm.opcaoAtualizarBoleto = false;
        }
        //vm.pesquisar(); 
        vm.email = vm.userEmail;
    }

   //vm.selecionarSacadoModal = function()
   //{    
   //    var modalInstance = $uibModal.open({
   //    templateUrl: 'app/cadastro/sacado/selecionar/index.html',
   //    controller: 'SacadoSelecionarController',
   //    controllerAs: 'controller',
   //    windowClass: 'inmodal',
   //    size: 'lg',
   //    }).result.then(function(data){
   //        vm.registrosOriginal = null;
   //        vm.registros = null;
   //        vm.filtro.sacado = null;
   //        vm.filtro.sacadoViewId = null;
   //        if (data != null)
   //        {
   //            vm.filtro.sacado = data;
   //            vm.filtro.sacadoViewId = data.viewId;
   //        }      
   //    });
   //}

    vm.pesquisar = function()
    {
        var dataOperacaoInformado = vm.filtro.operacaoInicial != null && vm.filtro.operacaoFinal != null;
        var dataVencimentoInformado = vm.filtro.vencimentoInicial != null && vm.filtro.vencimentoFinal != null;

        if (dataOperacaoInformado == false && dataVencimentoInformado == false)
        {
            toastr.error('Selecione um período.', 'Alerta');
            return;
        }

        // sacados
        /*
        if ((vm.filtro.sacado == null) && (vm.filtro.grupoSacado == null || vm.filtro.grupoSacado == '')) {
            toastr.error('Selecione um sacado.', 'Alerta');
            return;
        }
        */



        vm.registrosOriginal = null;
        vm.registros = null;


        if (vm.filtro.tipoSacado == 0) 
        {
            vm.filtro.cnpjSacado = vm.cnpjUsuarioSacado;
            vm.filtro.grupoSacado = null;
        } else 
        {
            vm.filtro.grupoSacado = vm.cnpjUsuarioSacado ? vm.cnpjUsuarioSacado.substring(0, 10) : '';
            vm.filtro.cnpjSacado = null;
        }

        
         
        console.log("FILTRO:",vm.filtro);


        vm.consultarPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/listar", vm.filtro).success(function(response){
            vm.registrosOriginal = response.response;
            vm.registros = response.response;
            //vm.email = response.email;
            //vm.cedenteViewId = vm.filtro.cedente.viewId;

            if (vm.registros == null || vm.registros.length == 0)
            {
                toastr.warning('Não foram encontrados lançamentos.', 'Alerta');
            }
            else
            {
                for (var i=0;i<vm.registros.length;i++)
                {
                    vm.registros[i].selecionado = true;
                }
            }

            vm.filtrarPesquisa();

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.baixarPdf = function() {
        if (!confirm('Deseja baixar os registros selecionados?')) {
            return;
        }

        var lancamentos = [];

        for (var i=0;i<vm.registros.length;i++)
        {
            if (vm.registros[i].selecionado)
            {
                lancamentos.push(vm.registros[i]);
            }
        }

        if (lancamentos.length == 0) {
            toastr.error('Selecione um lançamento.', 'Alerta');
            return;
        }

        /*
        if (lancamentos.length > 10) {
            toastr.error('Não é permitido o envio acima de 10 boletos.', 'Alerta');
            return;
        }
        */

        for (var i=0;i<lancamentos.length;i++) {
            vm.acaoTabelaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", lancamentos[i]).success(function(response, teste, teste1, req){
                vm.download(response, 'application/pdf', 'boleto_'+ req.data.numeroDocumento + '.pdf');
                //vm.download(response, 'application/pdf', 'boleto.pdf');
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
        
        vm.desmarcarTodos();
        vm.selecionadoTodos = false;
    }

    vm.enviarEmail = function() 
    {
        if (!confirm('Deseja enviar o e-mail para os registros selecionados?')) {
            return;
        }

        var lancamentos = [];
        var sacadoCnpj = '';
        var sacadoGrupo = '';

        if (vm.filtro.tipoSacado == 0) {
            if (vm.filtro.sacado != null) {
                sacadoCnpj = vm.filtro.cnpj;
            }
        }
        else {
            if (vm.filtro.grupoSacado != null) {
                sacadoGrupo = vm.filtro.grupoSacado;
            }
        }

        for (var i=0;i<vm.registros.length;i++)
        {
            if (vm.registros[i].selecionado)
            {
                lancamentos.push(vm.registros[i]);
            }
        }

        if (lancamentos.length == 0) {
            toastr.error('Selecione um lançamento.', 'Alerta');
            return;
        }
        if (lancamentos.length > 10) {
            toastr.error('Não é permitido o envio acima de 10 boletos.', 'Alerta');
            return;
        }

        var request = {
            email: vm.email,
            lancamentos: lancamentos,
            cedenteViewId: vm.cedenteViewId,
            sacadoViewId: vm.sacadoViewId,
            sacadoCnpj: sacadoCnpj,
            sacadoGrupo: sacadoGrupo,
        };

        vm.consultarPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/enviarEmailAgrupamento", request).success(function(response){
            
            //vm.items = null;
            //vm.registrosOriginal = null;
            //vm.registros = null;

            toastr.info('E-mail enviado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.cedente_consultar', {obj: fornecedor.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.fantasia != null && vm.filtro.fantasia != '')
            {
                if (!vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.desmarcarTodos();
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'lancamento':
                    vm.registros.reverse(function(a, b){
                        if(a.lancamento < b.lancamento) { return -1; }
                        if(a.lancamento > b.lancamento) { return 1; }
                        return 0;
                    })
                    break;codBanco
                case 'banco':
                    vm.registros.reverse(function(a, b){
                        if(a.codBanco < b.codBanco) { return -1; }
                        if(a.codBanco > b.codBanco) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.reverse(function(a, b){
                        if(a.nomeSacado < b.nomeSacado) { return -1; }
                        if(a.nomeSacado > b.nomeSacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'diasvencido':
                    vm.registros.reverse(function(a, b){
                        if(a.diasVencido < b.diasVencido) { return -1; }
                        if(a.diasVencido > b.diasVencido) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimento);
                        var dateB = new Date(b.dataVencimento);
                        return dateA - dateB;
                    });
                    break;
                case 'valortitulo':
                    vm.registros.reverse(function(a, b){
                        if(a.valorTitulo < b.valorTitulo) { return -1; }
                        if(a.valorTitulo > b.valorTitulo) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'lancamento':
                    vm.registros.sort(function(a, b){
                        if(a.lancamento < b.lancamento) { return -1; }
                        if(a.lancamento > b.lancamento) { return 1; }
                        return 0;
                    })
                    break;
                case 'banco':
                    vm.registros.sort(function(a, b){
                        if(a.codBanco < b.codBanco) { return -1; }
                        if(a.codBanco > b.codBanco) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.sort(function(a, b){
                        if(a.nomeSacado < b.nomeSacado) { return -1; }
                        if(a.nomeSacado > b.nomeSacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'diasvencido':
                    vm.registros.sort(function(a, b){
                        if(a.diasVencido < b.diasVencido) { return -1; }
                        if(a.diasVencido > b.diasVencido) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimento);
                        var dateB = new Date(b.dataVencimento);
                        return dateA - dateB;
                    });
                    break;
                case 'valortitulo':
                    vm.registros.sort(function(a, b){
                        if(a.valorTitulo < b.valorTitulo) { return -1; }
                        if(a.valorTitulo > b.valorTitulo) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.marcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.filtro.status == vm.registros[i].status)
            {
                vm.registros[i].selecionado = true;
            }
        }
    }

    vm.desmarcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            vm.registros[i].selecionado = false;
        }
    }

    vm.visualizarBoleto = function(item) {
        // verificar boleto vencido itau
        if (vm.opcaoAtualizarBoleto && item.codBanco == 341 && item.isVencido)
        {
            vm.verItauBoletoVencido(item);
        }
        else if (vm.opcaoAtualizarBoleto && item.isVencido) {
            vm.verBoletoVencido(item);
        }
        else {
            item.isGerarAtualizado = false;
            vm.acaoTabelaPromise = $http.post(APP_MNP + "/EmailCarteiraDinamica/verboleto", item).success(function(response){
            
                //vm.download(response, 'application/pdf', 'boleto.pdf');
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/email/carteira/modal/boleto/index.html',
                    controller: 'CarteiraModalBoletoController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                    resolve: {
                        item: function () {
                            return response;
                        },
                    }
                }).closed.then(function(){
                    //vm.listar();
                });

                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.verBoletoVencido = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/email/carteira/dinamica/vencido/index.html',
            controller: 'BoletoVencidoGerarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'md',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });
    }

    vm.verItauBoletoVencido = function(antecipacao)
    {
        vm.acaoTabelaPromise = $http.post(APP_MNP + "/emailCarteiraDinamica/itauboletovencidotoken", antecipacao)
        .then(function(response)
        { 
            var codigo = response.data;
            var modalInstance = $uibModal.open({
                templateUrl: 'app/email/carteira/dinamica/itau/boletovencido/index.html',
                controller: 'BoletoVencidoItauGerarController',
                controllerAs: 'controller',
                windowClass: 'inmodal',
                size: 'md',
                resolve: {
                    antecipacao: function () {
                        return antecipacao;
                    },
                    codigo: function () {
                        return codigo;
                    },
                }
            }).closed.then(function(){
                //vm.listar();
            });
        });
        
    }

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
angular
.module('inspinia').factory("UsuarioService", ['$http', 'APP_MNP', 'AuthService', 
    function ($http, APP_MNP, AuthService) {
    return {
        login: function(login, pwd){
            var data = {
                login: login,
                senha: pwd
            }
            return $http.post(APP_MNP + "/token/user", data).then(
                function(response){
                    AuthService.setToken(response.data.accessToken);
                    AuthService.setUser(response.data.userName);
                    AuthService.setEmpresa(response.data.empresa);
                    return response;
                },
                function (error) {
                    return error;
                }
            )
        },
        insert: function(usuario){
            return $http.post(APP_MNP + "/usuario/enviar", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        update: function(viewId, usuario){
            usuario.ViewId = viewId;
            return $http.post(APP_MNP + "/usuario/alterar", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        updatePassword: function(oldPassword, newPassword){
            usuario = {};
            usuario.oldPassword = oldPassword;
            usuario.newPassword = newPassword;
            return $http.post(APP_MNP + "/usuario/updatePassword", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        delete: function(usuario){
            return $http.post(APP_MNP + "/usuario/remove", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },       
        get: function (viewId) {
            return $http.get(APP_MNP + "/usuario/" + viewId)
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAll: function () {
            return $http.get(APP_MNP + "/usuario/GetAll")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getMenu: function (viewId) {
            return $http.get(APP_MNP + "/menu")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioNovaContaController', ['$scope', '$state', 'APP_MNP', '$http', '$location', '$cookieStore', 'toastr', 'APP_SUBDOMAIN',
      function($scope, $state, APP_MNP, $http, $location, $cookieStore, toastr, APP_SUBDOMAIN)
{
    var vm = this;
    vm.subdomain = '';
    vm.sacado = {
      tipo: '2',
      emailCadastro: '',
    };

    vm.init = function()
    {
      vm.s_subdomain();
    }    

    vm.s_subdomain = function()
    {
      vm.subdomain = $location.host();
        
      if (vm.subdomain == 'localhost') {
        vm.subdomain = APP_SUBDOMAIN;
      }
      else {
        vm.subdomain = vm.subdomain.split('.')[0];
      }
    }

    vm.incluir = function()
    {
      if (vm.sacado.emailCadastro == null)
      {
        toastr.error('Favor informar o campo E-mail.', 'Alerta');
        return;
      }

      if (vm.sacado.confimarEmailCadastro == null)
      {
        toastr.error('Favor informar o campo Confirmar E-mail.', 'Alerta');
        return;
      }

      if (vm.sacado.emailCadastro != vm.sacado.confimarEmailCadastro)
      {
        toastr.error('Favor confirmar novamente o campo Confirmar E-mail.', 'Alerta');
        return;
      }

      if (vm.sacado.confirmarSenha == null)
      {
        toastr.error('Favor informar o campo Confirmar Senha.', 'Alerta');
        return;
      }

      if (vm.sacado.senhaCadastro == null) 
      {
        toastr.error('Favor informar o campo Senha.', 'Alerta');
        return;
      }

      if (vm.sacado.senhaCadastro != vm.sacado.confirmarSenha)
      {
        toastr.error('Favor confirmar novamente o campo Confirmar Senha.', 'Alerta');
        return;
      }

      if (vm.subdomain == '')
      {
        toastr.error('Empresa não identificada.', 'Alerta');
        return;
      }
      
      vm.sacado.host = vm.subdomain;
      
      vm.incluirPromise = $http.post(APP_MNP + "/sacado/autocadastro", vm.sacado).success(function(response){
          $cookieStore.put('lastLoginSacado', vm.sacado.emailCadastro);
          $state.go('login.autenticar');
          toastr.info('Cadastro realizado com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
     
      //$state.go('completar_cadastro.finalizar');
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioLoginController', ['$state', '$location', 'AuthService', 'toastr', '$cookieStore', '$http', 'APP_MNP', 'APP_SUBDOMAIN',
  function ($state, $location, AuthService, toastr, $cookieStore, $http, APP_MNP, APP_SUBDOMAIN) {

  var vm = this;
  
  vm.criarConta = function()
  {
      $state.go("novo_cadastro.usuario_nova_conta");
  }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioConfirmarEmailController', ['$scope', '$state', 'APP_MNP', '$http', 'toastr',
      function($scope, $state, APP_MNP, $http, toastr)
{
    var vm = this;
    vm.resultado = 0;

    vm.init = function()
    {
        vm.confirmarCodigo($state.params.codigo);
    }

    vm.confirmarCodigo = function(codigo)
    {
        var fornecedor = {
            complemento: {
                codigoAtivacaoEmail: codigo
            }
        };

        vm.verificarPromise = $http.post(APP_MNP + "/cedente/verificarconta", fornecedor).success(function(response){
            vm.resultado = 1;
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            vm.resultado = 2;
            return error;
        });
    }

    vm.init();

}]);

angular.module('inspinia')
    .factory('AuthService', AuthService);

function AuthService ($localStorage, $q) {
    return {
    getToken : function () {
        return $localStorage.tokenCli;
    },
    setToken: function (token) {
        $localStorage.tokenCli = token;
    },
    getUser : function () {
        return $localStorage.user;
    },
    setUser: function (user) {
        $localStorage.user = user;
    },
    getEmpresa : function () {
        return $localStorage.empresa;
    },
    setEmpresa: function (empresa) {
        $localStorage.empresa = empresa;
    },
    getRole : function () {
        return $localStorage.role;
    },
    setRole: function (role) {
        $localStorage.role = role;
    },
    getEmpresaId : function () {
        return $localStorage.empresaId;
    },
    setEmpresaId: function (empresaId) {
        $localStorage.empresaId = empresaId;
    },
    getEmpresaMainId : function () {
        return $localStorage.empresaMainId;
    },
    setEmpresaMainId: function (empresaMainId) {
        $localStorage.empresaMainId = empresaMainId;
    },  
    getUserEmail : function () {
        return $localStorage.userEmail;
    },
    setUserEmail: function (email) {
        $localStorage.userEmail = email;
    },
    getUsoDeBoleto: function () {
        return $localStorage.usoDeBoleto;
    },    
    setUsoDeBoleto: function (id) {
        $localStorage.usoDeBoleto = id;
    },  
    getCnpjUsuarioSacado: function () {
        return $localStorage.cnpjUsuarioSacado;
    },    
    setCnpjUsuarioSacado: function (id) {
        $localStorage.cnpjUsuarioSacado = id;
    },      
    logout : function (data) {
        delete $localStorage.tokenCli;
        delete $localStorage.token;
        delete $localStorage.user;
        delete $localStorage.role;
        delete $localStorage.empresaId;
        delete $localStorage.empresaMainId;
        delete $localStorage.userEmail;
        delete $localStorage.usoDeBoleto;
        delete $localStorage.cnpjUsuarioSacado;
        $q.when();
    }
    };
}
angular.module('inspinia')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
});

function AuthInterceptor ($location, AuthService, $q) {
    return {
    request: function(config) {
        config.headers = config.headers || {};

        if (!config.skipInterceptor && AuthService.getToken()) {
            config.headers['Authorization'] = 'Bearer ' + AuthService.getToken();
        }
        
        return config;
    },

    responseError: function(response) {
        if (response.status === 401 || response.status === 403) {
        $location.path('/login');
        }

        return $q.reject(response);
    }
    }
}
'use strict';

angular.module('inspinia')
  .controller('MainController', ['$state', '$location', 'AuthService', 'toastr', '$cookieStore', '$http', 'APP_MNP', 'APP_SUBDOMAIN',
  function ($state, $location, AuthService, toastr, $cookieStore, $http, APP_MNP, APP_SUBDOMAIN) {

    var vm = this;
    vm.usuario = {};     
    vm.default = '';
    vm.logoempresa = '';
    vm.subdomain = '';

    vm.userName = AuthService.getUser();
    vm.empresaName = AuthService.getEmpresa();
    vm.empresaId = AuthService.getEmpresaId();
    vm.empresaMainId = AuthService.getEmpresaMainId();


    vm.init = function()
    {
      if ($cookieStore.get('lastLoginSacado') != null)
      {
        vm.usuario.Login = $cookieStore.get('lastLoginSacado');
      } 

      vm.s_subdomain();
    }

    vm.s_subdomain = function()
    {
        vm.subdomain = $location.host();
        
        if (vm.subdomain == 'localhost') {
          vm.subdomain = APP_SUBDOMAIN;
        }
        else {
          vm.subdomain = vm.subdomain.split('.')[0];
        }
        var host = vm.subdomain;
        
        if (host.indexOf('.') < 0) 
        {
            vm.logoempresa = 'assets/images/icons/logo.png';
        }
        else
        {
            var subdomain = host.split('.')[0];

            return $http.get(APP_MNP + "/cliente/imagelogo/" + subdomain)
            .then(function(response)
            { 
                vm.logoempresa = (APP_MNP + "/cliente/imagelogo/" + subdomain);
            }).catch(function (data) {
                vm.logoempresa = 'assets/images/icons/logo.png';
            });
        }
    }

    vm.init();

    vm.login = function()
    {
      if (vm.usuario.Login == null || vm.usuario.Login == '')
      {
          toastr.error('Informe o Login da empresa.', 'Login');
          return;
      }

      if (vm.usuario.Senha == null || vm.usuario.Senha == '')
      {
          toastr.error('Informe a Senha.', 'Login');
          return;
      }
     
      $cookieStore.put('lastLoginSacado', vm.usuario.Login);

      vm.loginPromise = vm.realizarLogin(vm.usuario.Login, vm.usuario.Senha);

      vm.loginPromise.then(function(result) {  
          if(result.data.error == null && result.data.authenticated)
          {
              vm.default = result.data.default;

              vm.userName = AuthService.getUser();
              vm.empresaName = AuthService.getEmpresa();
              vm.empresaId = AuthService.getEmpresaId();
              vm.empresaMainId = AuthService.getEmpresaMainId();

              $state.go("index.main");
          }
          else
          {
              toastr.error(result.data.message, 'Login');
          }
      });
    }

    vm.realizarLogin = function(login, pwd){
      var data = {
          login: login,
          senha: pwd,
          host: vm.subdomain
      }
      return $http.post(APP_MNP + "/sacado/Login", data).then(
          function(response){
              AuthService.setToken(response.data.accessToken);
              AuthService.setUser(response.data.userName);
              AuthService.setEmpresa(response.data.empresa);
              AuthService.setEmpresaId(response.data.empresaId);
              AuthService.setEmpresaMainId(response.data.empresaMainId);
              AuthService.setCnpjUsuarioSacado(response.data.cnpjUsuarioSacado);

              return response;
          },
          function (error) {
              return error;
          }
      )
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('HomeController', ['$state', '$scope', 'toastr', '$uibModal', 'AuthService', '$http', 'APP_MNP',
  function ($state, $scope, toastr, $uibModal, AuthService, $http, APP_MNP) {

    var vm = this;

    vm.init = function()
    {
      vm.userName = AuthService.getUser();
      vm.empresaName = AuthService.getEmpresa();
      vm.cnpjUsuarioSacado = AuthService.getCnpjUsuarioSacado();
 
    }

    vm.init();

  }]);

  angular.module('inspinia')
   .factory('modalService', ['$uibModal', '$sce', function($uibModal, $sce) {
       return {
           openModal: function(url) {
               var trustedUrl = $sce.trustAsResourceUrl(url);  // Marca a URL como segura
               
               $uibModal.open({
                   animation: true,
                   templateUrl: 'app/modal-template.html',
                   controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
                       $scope.urlToLoad = trustedUrl;  // Passa a URL segura para o modal

                       $scope.closeModal = function() {
                           $uibModalInstance.dismiss('close');
                       };
                   }],
                   size: 'lg',
                   backdrop: 'static',
                   keyboard: true
               });
           }
       };
   }]);


/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      // Login
      .state('login', {
        abstract: true,
        url: "/login",
        templateUrl: "app/usuario/autenticar.html",
        controller: 'UsuarioLoginController',
        controllerAs: 'controller',
      })
      .state('login.autenticar', {
        url: "/autenticar",
        controller: 'UsuarioLoginController',
        controllerAs: 'controller',
        templateUrl: "app/usuario/autenticar.html"
      })
      // Index
      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html"
      })
      .state('index.main', {
        url: "/main",
        templateUrl: "app/main/main.html",
        controller: 'HomeController',
        controllerAs: 'home',
        data: { pageTitle: 'Main' }
      })
      // Novo Cadastro
      .state('novo_cadastro', {
        abstract: true,
        url: "/novo_cadastro",
        templateUrl: "app/usuario/nova_conta.html",
        controller: 'UsuarioNovaContaController',
        controllerAs: 'controller',
      })
      .state('novo_cadastro.usuario_nova_conta', {        
        url: "/usuario_nova_conta",        
      })
      
      // Email > Carteira Dinamica
      .state('index.email_carteira_dinamica', {
        url: "/email_carteira_dinamica",
        templateUrl: "app/email/carteira/dinamica/index.html",
        controller: 'EmailCarteiraDinamicaController',
        controllerAs: 'controller'
      })

      $urlRouterProvider.otherwise('/login/autenticar');
  }

})();

angular
.module('inspinia')
.factory('PagerService', PagerService)

// SUBDOMAIN
.constant('APP_SUBDOMAIN', "perdizes")

// LOCAL
//.constant('APP_MNP', "https://localhost:44370/api")

// PRODUCAO ---
.constant('APP_MNP', "https://producao.moneynow.com.br/api") 

//teste do sergio

function PagerService() {
    // service definition
    var service = {};

    service.GetPager = GetPager;

    return service;

    // service implementation
    function GetPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 5
        pageSize = pageSize || 15;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
};

angular.module('inspinia').value('cgBusyDefaults',{
    message:'Carregando',
    templateUrl: 'app/components/common/loading.html'
  });

angular.module('inspinia').directive('icheck', icheck);

angular.module('inspinia')
.config( [
    '$compileProvider',
    function( $compileProvider )
    {   
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|data|image):/);
        // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
    }
])
.config(['$provide', function($provide) {
    $provide.decorator('$locale', ['$delegate', function($delegate) {
        $delegate.NUMBER_FORMATS.DECIMAL_SEP = ',';
        $delegate.NUMBER_FORMATS.GROUP_SEP = '.';
        return $delegate;
    }]);
}]);

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}

var angles = angular.module("angles", []);

  angles.chart = function (type) {
      return {
          restrict: "A",
          scope: {
              data: "=",
              options: "=",
              id: "@",
              width: "=",
              height: "=",
              resize: "=",
              chart: "@",
              segments: "@",
              responsive: "=",
              tooltip: "=",
              legend: "="
          },
          link: function ($scope, $elem) {
              var ctx = $elem[0].getContext("2d");
              var autosize = false;

              $scope.size = function () {
                  if ($scope.width <= 0) {
                      $elem.width($elem.parent().width());
                      ctx.canvas.width = $elem.width();
                  } else {
                      ctx.canvas.width = $scope.width || ctx.canvas.width;
                      autosize = true;
                  }

                  if($scope.height <= 0){
                      $elem.height($elem.parent().height());
                      ctx.canvas.height = ctx.canvas.width / 2;
                  } else {
                      ctx.canvas.height = $scope.height || ctx.canvas.height;
                      autosize = true;
                  }
              }

              $scope.$watch("data", function (newVal, oldVal) {
                  if(chartCreated)
                      chartCreated.destroy();

                  // if data not defined, exit
                  if (!newVal) {
                      return;
                  }
                  if ($scope.chart) { type = $scope.chart; }

                  if(autosize){
                      $scope.size();
                      chart = new Chart(ctx);
                  };

                  if($scope.responsive || $scope.resize)
                      $scope.options.responsive = true;

                  if($scope.responsive !== undefined)
                      $scope.options.responsive = $scope.responsive;

                  chartCreated = chart[type]($scope.data, $scope.options);
                  chartCreated.update();
                  if($scope.legend)
                      angular.element($elem[0]).parent().after( chartCreated.generateLegend() );
              }, true);

              $scope.$watch("tooltip", function (newVal, oldVal) {
                  if (chartCreated)
                      chartCreated.draw();
                  if(newVal===undefined || !chartCreated.segments)
                      return;
                  if(!isFinite(newVal) || newVal >= chartCreated.segments.length || newVal < 0)
                      return;
                  var activeSegment = chartCreated.segments[newVal];
                  activeSegment.save();
                  activeSegment.fillColor = activeSegment.highlightColor;
                  chartCreated.showTooltip([activeSegment]);
                  activeSegment.restore();
              }, true);

              $scope.size();
              var chart = new Chart(ctx);
              var chartCreated;
          }
      }
  }


  /* Aliases for various chart types */
  angles.directive("chart", function () { return angles.chart(); });
  angles.directive("linechart", function () { return angles.chart("Line"); });
  angles.directive("barchart", function () { return angles.chart("Bar"); });
  angles.directive("radarchart", function () { return angles.chart("Radar"); });
  angles.directive("polarchart", function () { return angles.chart("PolarArea"); });
  angles.directive("piechart", function () { return angles.chart("Pie"); });
  angles.directive("doughnutchart", function () { return angles.chart("Doughnut"); });
  angles.directive("donutchart", function () { return angles.chart("Doughnut"); });
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('icheck', icheck)
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('moneyMask', ['$timeout', 'moneyMaskService', function($timeout, moneyMaskService) {
        return {
          require: 'ngModel',
          link: function(scope, element, attrs, ctrl) {
              var execute = function () {
                  scope.$apply(function () {
                      ctrl.$setViewValue(moneyMaskService.fromStringToMoney(ctrl.$modelValue));
                      ctrl.$render();
                  });
              };
              element.bind('keyup', function () {
                  execute();
              });
              
              $timeout(function () { 
                  execute();
              }, 500);
           }
        };
     }])
     .factory("moneyMaskService", [ "$filter", function ($filter) {
        var _otherCharacters = /[^0-9]/g;
        var _zeros = /^0+/;
        
        var _fromStringToMoney = function (string) {
            //return $filter("currency")((_fromStringToNumber(string)/100).toFixed(2)).replaceAll('R$', 'R$ ');
            return $filter("currency")((_fromStringToNumber(string)/100).toFixed(2), "");
        };
        
        var _fromStringToNumber = function (string) {
            if (!string) return 0;
            return string.toString().replace(_otherCharacters, '').replace(_zeros, '') || 0;
        }
        
        return {
            fromStringToMoney: _fromStringToMoney
        };
    }])
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-success " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }])
    .directive('numericOnly', function(){
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
    
                modelCtrl.$parsers.push(function (inputValue) {
                    var transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g,'') : null;
    
                    if (transformedInput!=inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
    
                    return transformedInput;
                });
            }
        };
    })
    .directive("setModelOnChange", function() {
        return {
            require: "ngModel",
            link: function postLink(scope,elem,attrs,ngModel) {
            elem.on("change", function(e) {
                console.log("on change (from directive)", e);  
                var files = elem[0].files;
                ngModel.$setViewValue(files);
            })
            }
        }
    })
;

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/modal-template.html","<div class=\"modal-dialog\" style=\"width: 90%; margin: 2vh auto; height: 90vh;\"><div class=\"modal-content\" style=\"height: 100%; display: flex; flex-direction: column;\"><div class=\"modal-header\"><h3 class=\"modal-title\">Visualização do Documento</h3></div><div class=\"modal-body\" style=\"flex: 1; padding: 0;\"><iframe ng-src=\"{{urlToLoad}}\" style=\"width: 100%; height: 100%; border: none;\"></iframe></div><div class=\"modal-footer\"><button class=\"btn btn-success\" style=\"width: 100px\" ng-click=\"closeModal()\">Fechar</button></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content ng-scope\" ng-if=\"main.isOperacaoMoneyNow == \'1\'\" style=\"display: none;\"><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.consultarPainelPromise\" ng-click=\"home.modalDetalheSolicitacao(14)\"><div class=\"ibox-title\"><span class=\"label label-success pull-right\">antecipação</span><h5>Em Análise</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.painelDados != null ? home.painelDados.emAnalise : \'-\'}}</h1><small>operações</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.consultarPainelPromise\" ng-click=\"home.modalDetalheSolicitacao(2)\"><div class=\"ibox-title\"><span class=\"label label-warning pull-right\">antecipação</span><h5>Negociação</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.painelDados != null ? home.painelDados.emNegociacao : \'-\'}}</h1><small>operações</small></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" cg-busy=\"home.consultarPainelPromise\" ng-click=\"home.modalDetalheSolicitacao(4)\"><div class=\"ibox-title\"><span class=\"label label-primary pull-right\">antecipação</span><h5>Formalização</h5></div><div class=\"ibox-content\"><h1 class=\"no-margins\">{{home.painelDados != null ? home.painelDados.emFormalizacao : \'-\'}}</h1><small>operações</small></div></div></div></div></div>");
$templateCache.put("app/usuario/autenticar.html","<style>\r\n    body  \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"middle-box text-center animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px; margin-top: 100px;\"><div style=\"padding-right: 35px; padding-left: 35px;\"><div style=\"margin-top: 30px;\"><img width=\"270px\" style=\"margin-bottom: 0px\" src=\"..\\assets\\images\\icons\\logo.jpg\"></div><br><br><h3>SACADO</h3><p>Informe seu login e senha para autenticar</p><form class=\"m-t\" role=\"form\" cg-busy=\"main.loginPromise\"><div class=\"form-group\"><input ng-model=\"main.usuario.Login\" type=\"text\" class=\"form-control\" placeholder=\"Usuário\" required=\"\"></div><div class=\"form-group\"><input ng-model=\"main.usuario.Senha\" type=\"password\" class=\"form-control\" placeholder=\"Senha\" required=\"\"></div><button type=\"submit\" ng-click=\"main.login()\" class=\"btn btn-success block full-width m-b\">Acessar</button> <small>Não possui uma conta?</small> <button type=\"button\" ng-click=\"controller.criarConta()\" class=\"btn btn-warning block full-width m-b\">Quero criar uma conta</button></form><p class=\"m-t\"><small>Money Now &copy; 2025<br>ic: {{main.subdomain}}</small></p></div></div></div></div></div></div>");
$templateCache.put("app/usuario/nova_conta.html","<style>    \r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" style=\"margin-right: 10%; margin-left: 10%;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-arrow-right\"></i> Criar nova conta</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo</label><select class=\"form-control\" ng-model=\"controller.sacado.tipo\"><option value=\"1\">Pessoa Física</option><option value=\"2\">Pessoa Jurídica</option></select></div></div><div class=\"col-sm-4\" ng-if=\"controller.sacado.tipo == 1\"><div class=\"form-group\"><label class=\"col-form-label\">CPF do Sacado <span class=\"red\">*</span></label> <input type=\"text\" mask=\"999.999.999-99\" maxlength=\"20\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\" ng-if=\"controller.sacado.tipo == 2\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ do Sacado <span class=\"red\">*</span></label> <input type=\"text\" mask=\"99.999.999/9999-99\" maxlength=\"20\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código Sacado <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"10\" ng-model=\"controller.sacado.codigoSacado\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.sacado.emailCadastro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Confirmar E-mail <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.sacado.confimarEmailCadastro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Senha de Acesso <span class=\"red\">*</span></label> <input type=\"password\" ng-model=\"controller.sacado.senhaCadastro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Confirmar Senha <span class=\"red\">*</span></label> <input type=\"password\" ng-model=\"controller.sacado.confirmarSenha\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><span class=\"red\" style=\"font-size: 11px;\">* Campos de preenchimento obrigatórios.</span></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.incluirPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.incluir()\">Efetivar Cadastro</button></div></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">MoneyNow 1.0</div><div><strong>Copyright</strong> MoneyNow &copy; 2025</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/loading.html","<div style=\"background-image:url(\'assets/images/icons/loading.gif\');background-size: 50px 50px;margin: 0 auto;background-position:50% 20px;background-repeat:no-repeat\"></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><div style=\"text-align: center;\"><img alt=\"image\" width=\"100px\" class=\"img-circle\" src=\"assets\\images\\icons\\icon_rb.png\"><span class=\"m-t-md text-muted text-xs block\">{{main.empresaName}}</span></div></div><div class=\"logo-element\">MN</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\" href=\"#/index/main\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\">Home - SC</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-inbox\"></i> <span class=\"nav-label\">Gestão de Carteira</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.email_carteira_dinamica\">Geração de Boletos</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><div class=\"form-group\"><input type=\"text\" placeholder=\"Gestão de Talentos\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ui-sref=\"login.autenticar\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></nav></div>");
$templateCache.put("app/email/carteira/dinamica/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Geração de Boletos de Sacados</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Gestão de Carteira</a></li><li class=\"active\"><strong>Geração de Boletos Sacado</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Selecionar Lançamentos</h5><div class=\"ibox-tools\"><a ng-click=\"controller.redirectToURL(); $event.stopPropagation()\" title=\"Manual: Geração de Boleto\"><i class=\"fa fa-book\" style=\"color: white; font-size: 22px;\"></i></a> <a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"col-form-label\">Data de Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoFinal\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Data da Operação</label> <input type=\"date\" ng-model=\"controller.filtro.operacaoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.operacaoFinal\" class=\"form-control\"></div></div><br><div class=\"row\"><div class=\"col-sm-2\"><label class=\"col-form-label\">Sacado</label><select class=\"form-control\" ng-model=\"controller.filtro.tipoSacado\"><option ng-value=\"0\">Por CNPJ</option><option ng-value=\"1\">Por Grupo</option></select></div><div class=\"col-sm-4\" ng-if=\"controller.filtro.tipoSacado == 1\"><label class=\"col-form-label\">&nbsp;</label> <input type=\"text\" ng-model=\"controller.filtro.grupoSacado\" class=\"form-control\" mask=\"99.999.999\"></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><br><button class=\"btn btn-success\" style=\"width: 200px\" ng-click=\"controller.pesquisar()\">Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registros != null && controller.registros.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'lancamento\')\" style=\"width: 10px;\">Lançamento</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"width: 10px;\">Título</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado</th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">Vencimento</th><th ng-click=\"controller.ordenarResultado(\'diasvencido\')\" style=\"width: 60px;\">Dias em Atraso</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Banco</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Valor Título</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\"></td><td>{{p.lancamento}}</td><td style=\"white-space: nowrap; width: 1px;\">{{p.numeroDocumento}}</td><td>{{p.nomeSacado}}<br>E-mail: {{p.emailDestinatario}}</td><td ng-if=\"p.isVencido\" style=\"color: red;\">{{p.dataVencimento}}</td><td ng-if=\"p.isVencido == false\">{{p.dataVencimento}}</td><td>{{p.diasVencido}}</td><td>{{p.codBanco}} - {{p.nomeBanco}}</td><td>{{p.valorTitulo | currency:\'R$ \'}}</td><td><button ng-click=\"controller.visualizarBoleto(p)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\" cellspacing=\"1\"><tr><td style=\"width: 99%;\" colspan=\"4\"></td><td style=\"width: 1px;\"><button ng-click=\"controller.baixarPdf()\" style=\"margin-bottom: 2px; width: 200px\" class=\"btn btn-success\">Baixar PDF</button></td></tr><tr><td colspan=\"5\"></td></tr><tr ng-if=\"controller.filtro.sacado != null\"><td style=\"width: 90%;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>E-mail Cópia:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.email\" class=\"form-control\" style=\"width: 400px;\"></td><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.enviarEmail()\" class=\"btn btn-success\" style=\"width: 200px\">Enviar E-mail</button></td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/email/carteira/modal/boleto/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Visualizar Boleto</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.filePdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/email/carteira/dinamica/vencido/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Boleto</h5></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div ng-if=\"controller.usoDeBoleto === 1 || controller.usoDeBoleto === 0\" ng-class=\"{ \'col-sm-12\': controller.usoDeBoleto === 1 , \'col-sm-6\': controller.usoDeBoleto === 0 }\"><button class=\"btn btn-primary btn-block\" ng-mouseenter=\"controller.mostrarParagrafo = true\" ng-mouseleave=\"controller.mostrarParagrafo = false\" ng-click=\"controller.visualizarBoleto()\" ng-style=\"{\'margin\': controller.usoDeBoleto === 1 ? \'0 auto\' : \'\', \'width\': controller.usoDeBoleto === 1 ? \'50%\' : \'\'}\">Boleto Original</button></div><div ng-if=\"controller.usoDeBoleto === 2 || controller.usoDeBoleto === 0\" ng-class=\"{ \'col-sm-12\': controller.usoDeBoleto === 2, \'col-sm-6\': controller.usoDeBoleto === 0 }\"><button class=\"btn btn-success btn-block\" ng-click=\"controller.visualizarBoletoAtualizado()\" ng-style=\"{\'margin\': controller.usoDeBoleto === 2 ? \'0 auto\' : \'\', \'width\': controller.usoDeBoleto === 2 ? \'50%\' : \'\'}\">Boleto Atualizado</button></div></div><div class=\"row\" style=\"text-align: center;\"><br><p ng-show=\"controller.mostrarParagrafo\" style=\"color: brown; padding: 5px; padding-top: 5px;\"><b>Atenção! Desde 10/11/2018, a NPC (Nova Plataforma de Cobrança) desenvolvida pela FEBRAN (Federação Brasileira de Bancos) passou a exigir o registro de todos os boletos, permitindo que o recebimento dos boletos vencidos possam ser pagos respeitando todas as instruções que contenham encargos, independente do banco emissor e/ou do banco de pagamento. Portanto, mesmo que a segunda via do boleto que já está vencido, seja gerada com os dados originais, no momento do pagamento a NPC irá realizar a atualização dos valores de forma automática.</b></p></div><br></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/email/carteira/dinamica/itau/boletovencido/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Boleto</h5></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div class=\"col-sm-6\"><button class=\"btn btn-primary btn-block\" ng-click=\"controller.visualizarBoleto()\">Boleto Original</button></div><div class=\"col-sm-6\"><form method=\"POST\" action=\"https://ww2.itau.com.br/2viabloq/pesquisa.asp\" name=\"form\" target=\"novajanela\"><input type=\"hidden\" name=\"DC\" value=\"{{controller.codigo}}\"> <input type=\"submit\" class=\"btn btn-success btn-block\" name=\"2via\" value=\"Boleto Atualizado\"></form></div></div><br></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");}]);